module.exports = __webpack_public_path__ + "static/media/BannerLogo2_NJTVNews.f11c6098.svg";